import axios from "axios";
import { ROOT_URL } from "./connectingUrls";

export default {
  getData(secondUrl) {
    return axios.post(`${ROOT_URL}/${secondUrl}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });
  },

  login(loginCredentials, secondUrl) {
    return axios.post(`${ROOT_URL}/${secondUrl}`, loginCredentials, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  register(regCredentials, secondUrl) {
    return axios.post(`${ROOT_URL}/${secondUrl}`, regCredentials, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  logout(token) {
    return axios.get(`${ROOT_URL}/logout`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  fetchAllData(token, apiUrl, itemId) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${itemId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  fetchResponseData(token, apiUrl, statusId, taskTableName) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${statusId}/${taskTableName}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  fetchData(token, apiUrl) {
    return axios.get(`${ROOT_URL}/${apiUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  fetchReportResponseData(token, projectId, apiUrl) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${projectId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  storeData(token, secondUrl, storeData) {
    return axios.post(`${ROOT_URL}/${secondUrl}`, storeData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  storeDataErrorHandler(token, secondUrl, storeData) {
    return axios
      .post(`${ROOT_URL}/${secondUrl}`, storeData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        alert("something went wrong." + err.response.status);
        return null;
      });
  },

  updateSurvey(token, itemId, apiUrl) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${itemId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  changeDataStatus(token, itemId, apiUrl) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${itemId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  getCashOutDetails(token, apiUrl, param1, param2, param3) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${param1}/${param2}/${param3}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  changeDataStatusByPagination(
    token,
    apiUrl,
    statusId,
    search,
    currentPage,
    per_page
  ) {
    return axios.get(
      `${ROOT_URL}/${apiUrl}/${statusId}?query=${search}&page=${currentPage}&per_page=${per_page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  changeVerificationStatus(token, apiUrl, itemId) {
    return axios.post(`${ROOT_URL}/${apiUrl}`, itemId, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  getIndexDataByPagination(
    token,
    apiUrl,
    search,
    currentPage = 1,
    per_page,
    statusId = "",
    start_date = "",
    end_date = ""
  ) {
    return axios.get(
      `${ROOT_URL}/${apiUrl}?searchKey=${search}&page=${currentPage}&per_page=${per_page}&statusId=${statusId}&start_date=${start_date}&end_date=${end_date}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  getProjectDataByPagination(
    token,
    apiUrl,
    statusId,
    search,
    currentPage,
    per_page,
    project_id
  ) {
    return axios.get(
      `${ROOT_URL}/${apiUrl}?query=${search}&page=${currentPage}&per_page=${per_page}&statusId=${statusId}&project_id=${
        project_id ? project_id : null
      }`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  getNidDataByPagination(
    token,
    apiUrl,
    statusId,
    search,
    currentPage,
    per_page
  ) {
    return axios.get(
      `${ROOT_URL}/${apiUrl}/${statusId}?query=${search}&page=${currentPage}&per_page=${per_page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  getDasherTeamDataByPagination(
    token,
    apiUrl,
    statusId,
    search,
    currentPage,
    per_page
  ) {
    return axios.get(
      `${ROOT_URL}/${apiUrl}/${statusId}?query=${search}&page=${currentPage}&per_page=${per_page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  getResponsedDataByPagination(
    token,
    apiUrl,
    taskStatusId,
    taskTableName,
    search,
    currentPage,
    per_page
  ) {
    return axios.get(
      `${ROOT_URL}/${apiUrl}?query=${search}&page=${currentPage}&per_page=${per_page}&taskTableName=${taskTableName}&taskStatusId=${taskStatusId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  getResponsedDataByPaginationWithSearch(
    token,
    apiUrl,
    taskId,
    taskTableName,
    search
  ) {
    return axios.get(
      `${ROOT_URL}/${apiUrl}/${taskId}/${taskTableName}/${search}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  getAcceptResponse(token, apiUrl, taskId, taskTableName) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${taskId}/${taskTableName}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  getWithdrawalDataByPagination(
    token,
    apiUrl,
    statusId,
    search,
    currentPage,
    per_page
  ) {
    // console.log("search"+search);
    return axios.get(
      `${ROOT_URL}/${apiUrl}?statusId=${statusId}&search=${search}&page=${currentPage}&per_page=${per_page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  getBalanceWithdrawalStatus(
    token,
    apiUrl,
    statusId,
    search,
    currentPage,
    per_page,
    id,
  ) {
    // console.log("search"+search);
    return axios.get(
      `${ROOT_URL}/${apiUrl}?statusId=${statusId}&search=${search}&page=${currentPage}&per_page=${per_page}&id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  getExportData(token, apiUrl, statusId) {
    return axios.get(`${ROOT_URL}/${apiUrl}/${statusId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "blob",
      },
    });
  },

  transDocuments(token, id, storeData, secondUrl) {
    return axios.put(`${ROOT_URL}/${secondUrl}/${id}`, storeData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  deleteData(token, secondUrl, item) {
    return axios.delete(`${ROOT_URL}/${secondUrl}/${item}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
};
